/// <reference path="ApplyOfferController.js" />
/* DEVELOPER NOTE:

  Find and replace this string, '// DevComment: ' with '' if you want get some
  sweets debug messages. But you have to revert the changes for two reasons:
  1. We want to keep those lines in order to debug again.
  2. No production enviroment should have console o other test committed to
     production.

  Also, help us improve our debugging code. Thanks
*/
!function (global) {
    'use strict';

    var previousApplyOfferController = global.ApplyOfferController;
    var actionsPostLoginUtility = new ActionsPostLoginUtility();
    var spinnerLockedNUnlocked;

    function ApplyOfferController(options) {
        var options = options || {};
        var $globalConf;
        var $conf;
        var offerDetailsServices;
        var siteOrUniv;
        var context;
        var isLoggued;
        var isVip;
        var withVipNote;

        var $applyOfferBtn;
        var $vipNoteForm;
        var $vipNoteModal;
        var $backToResultsButton;

        var $hdnAuxVars;
        var jsPostLogin;
        var applyPostLogin;
        var applyFromQuickView = $('.js-conf').data("apply-from-quickview").toLowerCase() === "true";

        function init() {
            $globalConf = options.$globalConf;
            $conf = options.$conf;
            offerDetailsServices = options.offerDetailsServices;
            siteOrUniv = ''; // site, university
            context = 'offer-view'; // vip-note, view, questionnaires

            $applyOfferBtn = $('.js-apply-offer-btn:not(.js-vip-note-modal):not(.js-vip-note-modal .js-apply-offer-btn)');
            $vipNoteModal = $('.js-vip-note-modal');
            $vipNoteForm = $vipNoteModal.find('.js-vip-note-form');
            $backToResultsButton = $('.js-back-to-results-button');

            if ($conf.data('is-loggued') == 'True') {
                isLoggued = true;
            } else {
                isLoggued = false;
            }

            if ($conf.data('is-site') == 'True') {
                siteOrUniv = 'site';
            } else {
                siteOrUniv = 'university'
            }

            if ($conf.data('is-vip') == 'True') {
                isVip = true;
            } else {
                isVip = false;
            }

            if (siteOrUniv == 'site') {
                if (isVip == true) {
                    withVipNote = false;
                } else {
                    withVipNote = undefined;
                }
            } else {
                isVip = false;
            }

            // PostLogin params
            $hdnAuxVars = $('.js-hdnvars');
            jsPostLogin = JSON.parse($hdnAuxVars.val());
            applyPostLogin = jsPostLogin.applypostlogin;

            $vipNoteModal
                .on('shown.bs.modal', function () {
                    context = 'vip-note';
                    $applyOfferBtn = $(this).find('.js-apply-offer-btn');
                    $applyOfferBtn.off('click').on('click', applyOffer);
                })
                .on('hidden.bs.modal', function () {
                    context = 'offer-view';
                    $applyOfferBtn = $('.js-apply-offer-btn:not(.js-vip-note-modal):not(.js-vip-note-modal .js-apply-offer-btn)');
                    $applyOfferBtn.off('click').on('click', applyOffer);
                });

            $applyOfferBtn.on('click', applyOffer);
            postlogin();

            if (eeGlobal.mqDetector.isDevice('xs') && !$('.js-eesites-fixed-buttons').find('.js-apply-offer-btn').length) {
                $backToResultsButton.addClass('without-apply-button');
            }
        }



        function applyOffer(event) {
            // GA4 - se valida si la oferta es postulable desde detalle de oferta y se sobreesbribe el tipo de bot�n
            if (applyFromQuickView) {
                $('#ga4TypeButton').val('vista rapida');
            } else {
                // GA4 - Obtiene el valor de la posici�n del bot�n para el env�o del evento de aplicaci�n de oferta
                var data = $(this).data('ga4-typebutton');
                if (data !== undefined && data !== null) {
                    $('#ga4TypeButton').val(data);
                }
            }

            var params;
            var url;
            var handleResponse;
            var postLogindata;
            var urlBaseLogin;

            if (siteOrUniv == 'university') {
                $('#habeasModal').modal('show');
                setTimeout(function () {
                    $('#habeasModal').modal('hide');
                }, 6000);
            }

            if ($(this).attr('type') == 'submit') {
                withVipNote = true;
            } else {
                if (isVip == true) {
                    withVipNote = false;
                } else {
                    withVipNote = undefined;
                }
            }

            if ((siteOrUniv == 'site' || siteOrUniv == 'university') && context == 'offer-view' && isLoggued == true && isVip == false && withVipNote == undefined) {
                // Apply offer from site or univ, in view, loggued, without VIP, without questionnaires.

                // - Apply offer.
                // console.log('apply offer from view without vip note');

                params = addVerificationToken({});
                url = $(this).data('url');
                spinnerLockedNUnlocked = new SpinnerLockedNUnlocked({
                    $context: $applyOfferBtn
                });

                spinnerLockedNUnlocked.locked();

                handleResponse = function (data) {
                    spinnerLockedNUnlocked.unlocked();
                    $applyOfferBtn.addClass('hidden');
                    eeGlobal.notification.clean();
                    eeGlobal.notification.success({
                        title: $conf.data('apply-offer-notification-title'),
                        copy: $conf.data('apply-offer-notification-copy'),
                        scroll: true
                    });
                    $('.js-eesites-offer-notifications').empty();
                    eeGlobal.notification.success({
                        title: $conf.data('apply-offer-notification-title'),
                        copy: $conf.data('apply-offer-notification-copy'),
                        $target: $('.js-eesites-offer-notifications')
                    });
                }
            }

            if (siteOrUniv == 'site' && context == 'offer-view' && isLoggued == true && isVip == true && withVipNote == false) {
                // Apply offer from site or univ, in view, loggued, with VIP, without VIP Note, without questionnaires.

                // - Open VIP note.
                // console.log('open vip note');
            }

            if (siteOrUniv == 'site' && context == 'vip-note' && isLoggued == true && isVip == true && withVipNote == false) {
                // Apply offer from site or univ, in vip note form, loggued, with VIP, without VIP Note, without questionnaires.

                // - Apply offer.
                // console.log('apply offer from vip note without vip note');

                params = addVerificationToken({});
                if ($conf.data('apply-from-quickview').toLowerCase() === 'true') {
                    params[$('#IsQuickView').attr('name')] = $('#IsQuickView').val();
                }
                url = $(this).data('url');
                spinnerLockedNUnlocked = new SpinnerLockedNUnlocked({
                    $context: $(this)
                });

                spinnerLockedNUnlocked.locked();

                handleResponse = function (data) {
                    $applyOfferBtn = $('.js-apply-offer-btn:not(.js-vip-note-modal):not(.js-vip-note-modal .js-apply-offer-btn)');
                    $applyOfferBtn.addClass('hidden');
                    $vipNoteModal.modal('hide');
                    spinnerLockedNUnlocked.unlocked();
                    eeGlobal.notification.clean();
                    eeGlobal.notification.success({
                        title: $conf.data('apply-offer-notification-title'),
                        copy: $conf.data('apply-offer-notification-copy'),
                        scroll: true
                    });
                    $('.js-eesites-offer-notifications').empty();
                    eeGlobal.notification.success({
                        title: $conf.data('apply-offer-notification-title'),
                        copy: $conf.data('apply-offer-notification-copy'),
                        $target: $('.js-eesites-offer-notifications')
                    });
                }
            }

            if (siteOrUniv == 'site' && context == 'vip-note' && isLoggued == true && isVip == true && withVipNote == true) {
                // Apply offer from site or univ, in vip note form, loggued, with VIP, with VIP Note, without questionnaires.

                // - Apply offer with vip note.
                // console.log('apply offer with vip note');

                event.preventDefault();

                params = $vipNoteForm.serialize();
                url = $vipNoteForm.attr('action');
                spinnerLockedNUnlocked = new SpinnerLockedNUnlocked({
                    $context: $(this)
                });

                spinnerLockedNUnlocked.locked();

                handleResponse = function (data) {
                    $applyOfferBtn = $('.js-apply-offer-btn:not(.js-vip-note-modal):not(.js-vip-note-modal .js-apply-offer-btn)');
                    $applyOfferBtn.addClass('hidden');
                    $vipNoteModal.modal('hide');
                    spinnerLockedNUnlocked.unlocked();
                    eeGlobal.notification.clean();
                    eeGlobal.notification.success({
                        title: $conf.data('apply-offer-notification-title'),
                        copy: $conf.data('apply-offer-notification-copy'),
                        scroll: true
                    });
                    $('.js-eesites-offer-notifications').empty();
                    eeGlobal.notification.success({
                        title: $conf.data('apply-offer-notification-title'),
                        copy: $conf.data('apply-offer-notification-copy'),
                        $target: $('.js-eesites-offer-notifications')
                    });
                }
            }

            if ((siteOrUniv == 'site' || siteOrUniv == 'university') && context == 'offer-view' && isLoggued == false && (withVipNote == undefined || withVipNote == false)) {
                // Apply offer from site or univ, in vip note form, loggued, without VIP, without VIP Note, with questionnaires.

                postLogindata = $(this).data('login-params'); // Obtienes los par�metros actuales
                urlBaseLogin = $conf.data('url-login'); // URL base del login

                // Obtener el valor de data-ga4-typebutton
                var ga4TypeButton = $(this).data('ga4-typebutton');

                // Verificar si se ha obtenido el valor de data-ga4-typebutton y agregarlo a postLogindata
                if (ga4TypeButton) {
                    postLogindata.push({ "Name": "ga4TypeButton", "Value": ga4TypeButton });
                }

                if (siteOrUniv == 'university') {
                    $('#habeasModal').modal('show');
                    $(".close-habeas").click(function () {
                        $('#habeasModal').modal('hide');
                        actionsPostLoginUtility.shouldDoLogin({ auxParams: postLogindata, urlBase: urlBaseLogin });
                    });
                    setTimeout(function () {
                        $('#habeasModal').modal('hide');
                        actionsPostLoginUtility.shouldDoLogin({ auxParams: postLogindata, urlBase: urlBaseLogin });
                    }, 6000);
                } else {
                    actionsPostLoginUtility.shouldDoLogin({ auxParams: postLogindata, urlBase: urlBaseLogin });
                }
            }


            if (params != null || url != null) {

                // GA4 - Enviar evento de aplicaci�n de oferta micrositio

                offerDetailsServices
                    .getResults(params, url)
                    .then(function (data) {

                        //Permutive
                        permutive.track('applyJob', {
                            "job": _objectDataJob  //variable definida en Areas/JobOffers/Views/JobOfferDetail/Index.cshtml
                        });

                        // GA4 - Enviar evento de aplicaci�n de oferta micrositio
                        ga4ApplyOfferSE();

                        switch (data.Response) {
                            case 1:
                                return toQuestions(data.Url);
                                break;
                            case 2:
                                if (data.Url.includes('https://')) {
                                    data.Url = data.Url.replace('https://', "");
                                    window.open('https://' + data.Url, '_blank');
                                }
                                else if (data.Url.includes('http://')) {
                                    data.Url = data.Url.replace('http://', "");
                                    window.open('http://' + data.Url, '_blank');
                                }
                                else if (data.Url != null && data.Url != "") {
                                    window.open('//' + data.Url, '_blank');
                                }
                                else {
                                    //donothing
                                }
                                break;
                        }

                        if (eeGlobal.mqDetector.isMobile()) {
                            $backToResultsButton.addClass('without-apply-button');
                        }

                        

                        return handleResponse(data);
                    }).fail(function (data) {
                        // console.log('apply offer is fail');
                        return handleErrorResponse(data);
                    });
            }
        }

        function handleErrorResponse(data) {
            spinnerLockedNUnlocked.unlocked();
            eeGlobal.notification.clean();
            eeGlobal.notification.danger({
                title: 'Error',
                copy: data.statusText,
                scroll: true
            });
        }

        function toQuestions(url) {
            if (siteOrUniv == 'university') {
                $('#habeasModal').modal('show');
                $(".close-habeas").click(function () {
                    $('#habeasModal').modal('hide');
                    location.href = url;
                });
                setTimeout(function () {
                    $('#habeasModal').modal('hide');
                    location.href = url;
                }, 6000);
            } else {
                location.href = url;
            }
        }

        function addVerificationToken(data) {
            data.__RequestVerificationToken = $('input[name="__RequestVerificationToken"]').val();
            return data;
        }

        function postlogin() {
            var removedParameters = ['applyPostLogin', 'createAlertPostLogin'];
            var overwritingUrlOffer;
            var $postLogin = $('.js-login-extra-params');
            var $hdnAuxVars = $('.js-hdnvars');
            var userId = $conf.data('user-id');
            var quickView = 'False';
            var jsPostLogin = JSON.parse($hdnAuxVars.val());

            // Obtener el valor de 'ga4TypeButton' de la URL
            var urlParams = new URLSearchParams(window.location.search);
            var ga4TypeButtonValue = urlParams.get('ga4TypeButton');

            if (jsPostLogin) {
                // Initialization function.
                overwritingUrlOffer = new OverwritingUrl({
                    parameters: removedParameters
                });

                // GA4 - se valida si la oferta es postulable desde detalle de oferta y se sobreesbribe el tipo de bot�n
                if (!jsPostLogin.offerapplied && !jsPostLogin.isvip && applyFromQuickView) {
                    $('#ga4TypeButton').val('vista rapida');
                    // GA4 - Enviar evento de aplicaci�n de oferta micrositio
                    ga4ApplyOfferSE();
                }

                if (jsPostLogin.applypostlogin && jsPostLogin.isvip && !jsPostLogin.offerapplied && siteOrUniv == 'site') {
                    $('#ApplicationNoteLightBox').modal('show');
                } else if (jsPostLogin.applypostlogincorrect) {
                    eeGlobal.notification.clean();
                    eeGlobal.notification.success({
                        title: $conf.data('apply-offer-notification-title'),
                        copy: $conf.data('apply-offer-notification-copy'),
                        scroll: true
                    });
                    $('.js-eesites-offer-notifications').empty();
                    eeGlobal.notification.success({
                        title: $conf.data('apply-offer-notification-title'),
                        copy: $conf.data('apply-offer-notification-copy'),
                        $target: $('.js-eesites-offer-notifications')
                    });

                    if (eeGlobal.mqDetector.isMobile()) {
                        $backToResultsButton.addClass('without-apply-button');
                    }

                    if (jsPostLogin.jobofferapply == "redirectwebservice") {
                        if (jsPostLogin.wsurl.includes('https://')) {
                            jsPostLogin.wsurl = jsPostLogin.wsurl.replace('https://', "");
                            window.open('https://' + jsPostLogin.wsurl, '_blank');
                        }
                        else if (jsPostLogin.wsurl.includes('http://')) {
                            jsPostLogin.wsurl = jsPostLogin.wsurl.replace('http://', "");
                            window.open('http://' + jsPostLogin.wsurl, '_blank');
                        }
                        else {
                            window.open('//' + jsPostLogin.wsurl, '_blank');
                        }
                    }
                    // GA4 - Enviar evento de aplicaci�n de oferta micrositio
                    $('#ga4TypeButton').val(ga4TypeButtonValue);
                        ga4ApplyOfferSE();
                }
            }
        }

        init();
        /*return {}*/
    }

    ApplyOfferController.noConflict = function noConflict() {
        global.ApplyOfferController = previousApplyOfferController;
        return ApplyOfferController;
    };

    global.ApplyOfferController = ApplyOfferController;

    function ga4ApplyOfferSE() {
        var offerDataGa4 = {
            id: offerData.offerID,
            section: "Detalle de oferta",
            button_type: $('#ga4TypeButton').val(),
            title: offerData.title,
            company: offerData.company,
            salary: offerData.salary,
            position: 1,
            brand: "Micrositio",
            category: "Candidato",
            location: offerData.location,
            profession: offerData.profession,
            experience: offerData.experience,
            education: offerData.educationLevel,
            equivalentPositions: offerData.equivalentPositions,
            sector: offerData.sector,
            level: offerData.offerLevel,
            list_id: "resultado_ofertas",
            list_name: "Resultado Ofertas"
        };
        postulationOfferEventSE(offerDataGa4);
    }
}(this);
